import React from 'react'
import { Link } from 'react-router-dom'
import './SearchHeader.css'
import logo from '../searchgull_logo.svg'

class PlainHeader extends React.Component {
  render() {
    return (
      <div className="search-header">
        <div className="search-header-left">
          <Link to="/"><img src={logo} className="search-header-logo" alt="SearchGull" /></Link>
          
        </div>
        <div className="search-header-right">
        <Link to="/settings">Settings</Link>
        <Link to="/about">About</Link>
        </div>
    </div>
    )
  }
}

export default PlainHeader;


// WEBPACK FOOTER //
// ./src/components/PlainHeader.js